export const validateCPF = (cpf: string): boolean => {
  cpf = cpf.replace(/[^\d]/g, '');
  if (cpf.length !== 11) {
    return false;
  }

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf[i]) * (10 - i);
  }

  let firstVerificationDigit = 11 - (sum % 11);
  if (firstVerificationDigit > 9) {
    firstVerificationDigit = 0;
  }

  if (parseInt(cpf[9]) !== firstVerificationDigit) {
    return false;
  }

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf[i]) * (11 - i);
  }

  let secondVerificationDigit = 11 - (sum % 11);
  if (secondVerificationDigit > 9) {
    secondVerificationDigit = 0;
  }

  if (parseInt(cpf[10]) !== secondVerificationDigit) {
    return false;
  }

  return true;
};
